module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "el-dialog__close el-icon el-icon-close align-right",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('div', [_c('ol', _vm._l((_vm.allWidgets), function(widget, index) {
    return _c('li', [_c('h2', [_vm._v(_vm._s(widget.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(widget.desc))]), _vm._v(" "), _c('el-button', {
      staticClass: "btn-add-widgets el-button el-small",
      attrs: {
        "disabled": widget.disable
      },
      on: {
        "click": function($event) {
          return _vm.addWidget(widget, index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('static.accountInformation.addWidgetBtn')))])], 1)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-000f83b9","hasScoped":false}!./src/app/components/overviewWidgets/overviewWidgets.html
// module id = 2888
// module chunks = 1